cb.define([], function() {
  var PC_pc_productlist_query_filterVM_Extend = {
    doAction: function(name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function(viewmodel) {
      viewmodel.on('beforeSearch', (args) => {
        let prodcutTags = args.commonVOs.filter(v => v.itemName === "prodcutTag")
        if (prodcutTags.length && prodcutTags[0].value1.length > 1) {
          args.isDistinct = true;
        }
      });
      viewmodel.on('afterInit', (args) => {
        //组织附默认值
        let orgId = cb.rest.AppContext.user.orgId;
        let userOrgs = cb.rest.AppContext.user.userOrgs;
        let defaultValue = { id: orgId };
        let currentOrg = userOrgs && userOrgs.find(function(item) {
          return item.org === orgId;
        });
        if (currentOrg) {
          defaultValue.code = currentOrg.org_code;
          defaultValue.name = currentOrg.org_name;
        }
        const userType = cb.rest.AppContext.user.userType
        //只能参照到当前用户有权限的组织
        if ((userType === 0 || userType === 1) && viewmodel.get("productApplyRange.orgId")) {
          viewmodel.get("productApplyRange.orgId").getFromModel().setValue([defaultValue]);
        }
        // 电商仓 过滤
        if(viewmodel.get('detail.omsWarehouse')){
          let condition = {
            "isExtend": true,
            simpleVOs: []
          };
          condition.simpleVOs.push({
            field: 'eStore',
            op: 'in',
            value1: 1
          });
          viewmodel.get('detail.omsWarehouse').getFromModel().setFilter(condition);
        }
      });
    }
  }
  try {
    module.exports = PC_pc_productlist_query_filterVM_Extend;
  } catch (error) {

  }
  return PC_pc_productlist_query_filterVM_Extend;
});


// WEBPACK FOOTER //
// ./src/client/business/PC/pc_productlist_query_filterVM.Extend.js